import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import { HStack, VStack } from 'tio-ui/components/layout';
import SectionPanel from 'tio-ui/components/section-panel';
import Text from 'tio-ui/components/text';
import { PhChatsCircle, PhLifebuoy, PhQuestion, PhUsersThree } from 'ember-phosphor-icons';

<template>
  <VStack class="gap-6">
    {{! Ask our student loan coaches }}
    <SectionPanel
      @headingLevel={{3}}
      @icon={{PhChatsCircle}}
      @iconColor="violet"
      @title={{t "coaching.about.ask_our_coaches"}}
    >
      <:body>
        <HStack>
          <VStack>
            <Text @tag="p">
              {{t "coaching.about.coaches_info_1"}}
            </Text>
            <Text @tag="p">
              {{t "coaching.about.coaches_info_2"}}
            </Text>
          </VStack>
          <div class="tio-row-flush sm:w-1/3 sm:pl-7 sm:border-l-4">
            <LinkTo
              @route="authenticated.repaying-student-debt.coaching.schedule"
              class="tio-anchor text-lg"
            >
              {{t "coaching.about.ask_coaches_link_text"}}
            </LinkTo>
          </div>
        </HStack>
      </:body>
    </SectionPanel>

    {{! Get program support }}
    <SectionPanel
      @headingLevel={{3}}
      @icon={{PhLifebuoy}}
      @iconColor="green"
      @title={{t "coaching.about.get_support"}}
    >
      <:body>
        <HStack>
          <VStack>
            <Text @tag="p">
              {{t "coaching.about.support_info_pt1"}}
              {{t
                "coaching.about.support_info_pt2"
                class="tio-fg-info hover:tio-fg-info-h underline font-semibold"
                htmlSafe=true
              }}
              {{t "coaching.about.support_info_pt3"}}
            </Text>
          </VStack>
          <div class="tio-row-flush sm:w-1/3 sm:pl-7 sm:border-l-4">
            <LinkTo @route="authenticated.contact-us" class="tio-anchor text-lg">
              {{t "coaching.about.chat_link_text"}}
            </LinkTo>
          </div>
        </HStack>
      </:body>
    </SectionPanel>

    {{! See previously asked questions }}
    <SectionPanel
      @headingLevel={{3}}
      @icon={{PhQuestion}}
      @iconColor="amber"
      @title={{t "coaching.about.previous_questions"}}
    >
      <:body>
        <HStack>
          <VStack>
            <Text @tag="p">
              {{t "coaching.about.questions_info"}}
            </Text>
          </VStack>
          <div class="tio-row-flush sm:w-1/3 sm:pl-7 sm:border-l-4">
            <a href="https://www.tuition.io/blog/" class="tio-anchor text-lg">
              {{t "coaching.about.coach_blog_link_text"}}
            </a>
          </div>
        </HStack>
      </:body>
    </SectionPanel>

    {{! Learn about our coaches }}
    <SectionPanel
      @headingLevel={{3}}
      @icon={{PhUsersThree}}
      @iconColor="blue"
      @title={{t "coaching.about.learn_about_coaches"}}
    >
      <:body>
        <VStack @collapsed={{true}}>
          <Text @tag="p">
            {{t "coaching.about.learn_coaches_info_1"}}
          </Text>
          <Text @tag="p">
            {{t "coaching.about.learn_coaches_info_2"}}
          </Text>
          <Text @tag="p">
            {{t "coaching.about.learn_coaches_info_3"}}
          </Text>
        </VStack>
      </:body>
    </SectionPanel>
  </VStack>
</template>
